import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import View from "./View";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

const mapStateToProps = (state: RootState, props: any) => ({
  isSingaporeAccount: selectors.isSingaporeAccount(state),
  supplierPayoutType: selectors.supplierPayoutType(state),
  features: selectors.getFeatures()
});

const mapDispatchToProps = {
  setSupplierPayoutType: actions.setSupplierPayoutType,
  resetSelectedPayees: actions.resetSelectedPayees,
  removeForm: actions.removeForm
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(View);
